import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Button } from 'src/components/ui'
import { IProperty } from 'src/interfaces/IProperty'

interface ISafeDealBanner {
  property: IProperty
}

// Sells the platform differentiator right where the deal happens: agree
// directly, generate the contract, close safely — no realtor. The CTA lands on
// the agreement generator pre-filled from this listing (guests go through
// login first and return here via the auth guard).
const SafeDealBanner: FC<ISafeDealBanner> = ({ property }) => {
  const { t } = useTranslation('', { keyPrefix: 'safe_deal' })
  const navigate = useNavigate()

  const steps = [t('step_agree'), t('step_generate'), t('step_sign')]

  return (
    // a card of the listing column: the three steps side by side on a desktop
    <section className="flex flex-col gap-4 p-5 md:p-6 bg-surface rounded-2xl shadow-card">
      <h2 className="m-0 text-[1.375rem] font-extrabold leading-7 text-ink">{t('title')}</h2>
      <ol className="grid gap-3 md:grid-cols-3 m-0 p-0 list-none">
        {steps.map((step, index) => (
          <li
            key={index}
            className="flex gap-2.5 items-start text-[0.9375rem] leading-[1.375rem] text-ink"
          >
            <span className="flex items-center justify-center w-6 h-6 shrink-0 rounded-full bg-brand-soft text-brand-ink text-xs font-bold">
              {index + 1}
            </span>
            {step}
          </li>
        ))}
      </ol>
      <Button
        className="w-full md:w-auto md:self-start"
        onClick={() => navigate(`/agreement?propertyId=${property.id}`)}
      >
        {t('cta')}
      </Button>
    </section>
  )
}

export default SafeDealBanner
